import {
  GUIDELINE_ALL_GET, GUIDELINE_ALL_GET_SUCCESS, GUIDELINE_ALL_GET_FAILURE
} from './mutation-types'

export default {
  state: {
    guidelinesAll: []
  },
  getters: {
    guidelinesAll: state => {
      return state.guidelinesAll
    }
  },
  actions: {
    [GUIDELINE_ALL_GET] ({dispatch, state, commit}, params = null) {
      var data = {}
      dispatch('apiGet', {url: '/master/guidelines/all_get', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GUIDELINE_ALL_GET_FAILURE, res.data)
          } else {
            commit(GUIDELINE_ALL_GET_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [GUIDELINE_ALL_GET_FAILURE] (state, data) {
      console.log('GUIDELINE_ALL_GET_FAILURE')
    },
    [GUIDELINE_ALL_GET_SUCCESS] (state, data) {
      console.log('GUIDELINE_ALL_GET_SUCCESS')
      state.guidelinesAll = data.data.data
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/guideline.js